import React from 'react'
import { useDispatch } from 'react-redux'
import UserEditor, { UserEditorProps } from './User/UserEditor'
import ActuatorEditor, { ActuatorEditorProps } from './HomePowerStation/ActuatorEditor'
import PasswordEditor, { PasswordEditorProps } from './User/PasswordEditor'
import { useTypedSelector } from '../State/RootReducer'
import PvModuleEditor, { PvModuleEditorProps } from '../Routes/Administration/PvModules/PvModuleEditor'
import { removeModal } from '@e3dc-react/shell/State/Modals/ModalActions'
import { Modal } from '@e3dc-react/shell/State/Modals/ModalModels'
import { ConfirmationModalProps, InformationModalProps, IPinEditorProps, ProjectNameEditorProps } from '../Hooks/useModals'
import { ConfirmationDialog, InformationDialog } from '@e3dc-react/shell/Elements/Dialog'
import InstallationAddressEditor, { InstallationAddressEditorProps } from '../Routes/HomePowerStation/SystemProperties/InstallationAddressEditor'
import IPinEditor from './User/IPinEditor'
import CompanyEditor from './User/CompanyEditor'
import InviteEditor, { InviteEditorProps } from 'src/Libs/company-settings/components/InviteEditor'
import BatterExportModuleEditor, { BatteryExportModuleProps } from 'src/Routes/Administration/BatteryExportModules/BatteryExportModuleEditor'
import InstallationDocumentUploadModal, { InstallationDocumentUpload } from 'src/Elements/Documents/UploadDocumentModal'
import AddWallboxDialog, { AddWallboxDialogProps } from 'src/Libs/wallboxes/components/dialogs/AddWallboxDialog'
import LogoutModal, { LogoutModalProps } from './User/UserSettings/LogoutModal'
import { ToggleIdlePeriodDialog, type ToggleIdlePeriodDialogProps } from 'src/Libs/smart-charge'
import { InstallationAccessInviteDialog, InstallationAccessInviteDialogProps } from 'src/Libs/installation-rights-management'
import LanguageModal, { LanguageModalProps } from './User/UserSettings/LanguageModal'
import InstallationAccessSettingsDialog, {
  InstallationAccessSettingsDialogProps,
} from 'src/Libs/installation-rights-management/components/dialogs/InstallationAccessSettingsDialog'
import { InstallationStatementDialog, InstallationStatementDialogProps } from 'src/Libs/installation-statement/components'
import {
  ShopLeavingConfirmationModal,
  ShopLeavingConfirmationModalProps,
  ShopCheckoutSideBar,
  ShopCheckoutSideBarModalProps,
  PowerMeterModal as ShopPowerMeterModal,
  PowerMeterModalProps as ShopPowerMeterModalProps,
  TransformerModal as ShopTransformerModal,
  TransformerModalProps as ShopTransformerModalProps,
  RetrofitBatteryModal as ShopRetrofitBatteryModal,
  RetrofitBatteryModalProps as ShopRetrofitBatteryModalProps,
  ShopHintModal,
  ShopHintModalProps,
  NewShippingAddressModal as ShopNewShippingAddressModal,
  NewShippingAddressModalProps as ShopNewShippingAddressModalProps,
  BillingAndShippingAddressModal as ShopBillingAndShippingAddressModal,
  BillingAndShippingAddressModalProps as ShopBillingAndShippingAddressModalProps,
  MoreInfoModal as ShopMoreInfoModal,
  MoreInfoModalProps as ShopMoreInfoModalProps,
  ShopSaveSystemConfigurationModal,
  ShopSaveSystemConfigurationModalProps,
  ShopUpdateSystemConfigurationModal,
  ShopUpdateSystemConfigurationModalProps,
  ShopRetrofitBatterySingleProductModal,
  ShopRetrofitBatterySingleProductModalProps,
  ShopOrderHistoryDetailsModal,
  ShopOrderHistoryDetailsModalProps,
  ShopAdminModal,
  ShopAdminModalProps,
  AdditionalProductsModalProps as ShopAdditionalProductsModalProps,
  AdditionalProductsModal as ShopAdditionalProductsModal,
} from 'src/Libs/shop'
import { SimpleTextDialogProps, SimpleTextDialog } from 'src/Elements/Dialogs'
import ImagePreviewModal, { ImagePreviewProps } from './Documents/ImagePreviewModal'
import HotWaterSupplyDialog, { HotWaterSupplyDialogProps } from 'src/Libs/smart-home/components/dialogs/HotWaterSupplyDialog'
import FarmParticipantSelector, { FarmParticipantSelectorProps } from './Farm/FarmParticipantSelector'
import NotificationModal, { NotificationModalProps } from 'src/Libs/notifications/components/modals/NotificationModal'
import DeleteProfileDialog, { DeleteProfileProps } from './User/UserProfile/delete-profile/DeleteProfileDialog'
import CompanyShowroomModal, { CompanyShowroomProps } from 'src/Libs/company-settings/components/CompanyShowroomModal'
import NotificationMessageModal, { NotificationMessageModalProps } from 'src/Libs/notifications/components/NotificationMessageModal'
import PowerPriceChartModal, {
  PowerPriceChartModalProps,
} from 'src/Libs/dashboard-widgets/widgets/dynamic-power-price/power-price-chart/PowerPriceChartModal'
import ManufacturerConnectionTermsDialog, {
  ManufacturerConnectionTermsProps,
} from 'src/Libs/e-mobility/vehicle-integration/components/manufacturer-list/ManufacturerConnectionTermsDialog'
import ChargeModal, { ChargeModalProps } from 'src/Libs/e-mobility/vehicle-integration/components/state-of-charge/ChargeModal'
import AssignManagerDialog, { AssignManagerDialogProps } from 'src/Libs/company-settings/components/AssignManagerDialog'
import {
  ShopProductImageModalProps,
  ShopPromotionCodeModalProps,
  ShopSmartMeterModalProps,
  ShopSmartMeterDocumentUploadModalProps,
} from 'src/Libs/shop/models/shop-modal-props.model'
import { ShopPromotionCodeModal } from 'src/Libs/shop/components/PromotionCode'
import SmartMeterModal from 'src/Libs/shop/components/SystemConfiguration/SmartMeterModal'
import ShopProductImageModal from 'src/Libs/shop/components/ShopProduct/ShopProductImageModal'
import SmartMeterDocumentUploadModal from 'src/Libs/shop/components/SystemConfiguration/SmartMeter/SmartMeterDocumentUploadModal'
import {
  InstallationAccessRequestDialog,
  InstallationAccessRequestDialogProps,
  NewInstallationModal,
  NewInstallationModalProps,
  RenameInstallationModal,
  RenameInstallationModalProps,
} from 'src/Libs/installations'
import {
  OwnerAccessRequestDialog,
  OwnerAccessRequestDialogProps,
  InstallationAccessRightDialog,
  InstallationAccessRightDialogProps,
} from 'src/Libs/installation-rights-management/components'
import {
  LuoxDirectMarketingDetails,
  ExtensionDetailsProps,
  OStromDetails,
  OStromDeleteConnectionModal,
  TibberDetails,
  TibberDeleteConnectionModal,
  ExtensionDeleteConnectionModalProps,
  LuoxDynamicTariffDetails,
  EonDetails,
  Ai360PowerShareDetails,
  Ai360PowerFixDetails,
  Ai360PowerShareDeleteConnectionModal,
  Ai360PowerFixDeleteConnectionModal,
  SmartMeterRecommendationModal,
  SmartMeterRecommendationModalProps,
} from 'src/Libs/installation-extensions'
import { WallboxWeekDaysDialog, WallboxWeekDaysDialogProps } from 'src/Libs/wallboxes/components'
import DashboardEditor, { DashboardEditorProps } from '../Libs/dashboard/components/DashboardEditor'
import CookieModal, { CookieModalProps } from './Framework/CookieModal'
import { TestRunDetailsModal, TestRunDetailsModalProps } from 'src/Libs/installation-details/components/system-details/modals'
import {
  ChangeInstallationOwnerModal,
  ChangeInstallationOwnerModalProps,
  EditAccessStartAtModal,
  EditAccessStartAtModalProps,
} from 'src/Libs/installation-details/components/modals'
import { GrantCompanyAccessModal, GrantCompanyAccessModalProps } from 'src/Libs/installation-details/components/companies-with-access/modals'
import { GrantInstallerAccessModal, GrantInstallerAccessModalProps } from 'src/Libs/installation-details/components/installers-with-access'
import { ChangeLocationDialogProps, ChangeLocationDialog } from 'src/Libs/installation-details/components'
import { SystemChartEditorProps } from 'src/Libs/chart-kit'
import ChartLayoutEditor, { ChartLayoutEditorProps } from 'src/Libs/chart-kit/editor/components/ChartLayoutEditor'
import SystemChartEditor from 'src/Libs/chart-kit/editor/components/Editor'
import { DynamicTariffSettingsDateRangeModal, DynamicTariffSettingsDateRangeModalProps } from 'src/Libs/dynamic-tariff-settings/components/modal'
import { AmazonCodeDialog, AmazonCodeDialogProps } from 'src/Libs/referral/components'
import { InexogyDetails } from 'src/Libs/installation-extensions/components/inexogy'
import LuoxDynamicTariffDeleteConnectionModal from 'src/Libs/installation-extensions/components/luox/dynamic-tariff/helpers/LuoxDynamicTariffDeleteConnectionModal'
import DeleteProfileSurveyDialog, { DeleteProfileSurveyDialogProps } from './User/UserProfile/delete-profile/DeleteProfileSurveyDialog'
import {
  CategoryEditor,
  CategoryEditorProps,
  DeleteCategoryDialog,
  DeleteCategoryProps,
  DownloadItemEditor,
  DownloadItemEditorProps,
  MoveDownloadItemEditorProps,
  MoveDownloadItemDialog,
  ProtectedFileDialogProps,
} from 'src/Libs/downloads/components'
import UploadFileDialog, { UploadFileDialogProps } from 'src/Libs/downloads/components/upload-file/UploadFileDialog'
import {
  InstallationSaveDialog,
  InstallationSaveDialogProps,
  InstallationDeleteDialog,
  InstallationDeleteDialogProps,
  EditBadgeDialogProps,
} from 'src/Libs/flow/advanced-settings/components/Dialogs'
import ReplaceFileDialog, { ReplaceFileDialogProps } from 'src/Libs/downloads/components/download-item-editor/ReplaceFileDialog'

/** New E-Mobility START */
import {
  EMobilityChargingSessionDetailsModal,
  EMobilityChargingSessionDetailModalProps,
  InvalidSelectedDateRangeExportSessionDialog,
  InvalidSelectedDateRangeExportSessionDialogProps,
  NoDateRangeSelectedExportSessionsDialog,
  NoDateRangeSelectedExportSessionsDialogProps,
  ReimbursementExportSessionsDialogProps,
  ReimbursementExportSessionsDialog,
} from 'src/Libs/e-mobility/charging-sessions'
import { AssignTariffDialogProps, AssignTariffDialog } from 'src/Libs/e-mobility/wallboxes'
import {
  AddTariffDialogProps,
  AddTariffDialog,
  DeleteTariffDialog,
  DeleteTariffDialogProps,
  EditTariffDialog,
  EditTariffDialogProps,
  TariffDetailsDialog,
  TariffDetailsDialogProps,
} from 'src/Libs/e-mobility/tariffs'
import {
  EditChargingCardDialog,
  EditChargingCardDialogProps,
  DeleteChargingCardDialog,
  DeleteChargingCardDialogProps,
  LinkedWallboxesOverviewDialog,
  LinkedWallboxesOverviewDialogProps,
  ChargingCardToWallboxLinkDialog,
  ChargingCardToWallboxLinkDialogProps,
  UnmanagedModeInfoDialog,
  UnmanagedModeInfoDialogProps,
  ChargingCardDetailsModalProps,
  ChargingCardDetailsModal,
} from 'src/Libs/e-mobility/charging-cards'
/** New E-Mobility END */

/** Old E-Mobility START */
import EMobilityChargingCardEditor, {
  EMobilityChargingCardEditorProps,
} from 'src/Libs/e-mobility/emobility-charging-cards/edit-charging-card/EMobilityChargingCardEditor'
import {
  EMobilityChargingSessionDetailsModalV1,
  EMobilityChargingSessionDetailModalPropsV1,
} from 'src/Routes/EMobility/EMobilityChargingSessionDetailsModalV1'
import ExportChargingCardEditor, {
  ExportChargingCardEditorProps,
} from 'src/Libs/e-mobility/emobility-charging-cards/export-charging-card/ExportChargingCardEditor'
import EMobilityChargingSessionsOverviewModal, {
  EMobilityChargingSessionsOverviewModalProps,
} from 'src/Libs/e-mobility/emobility-charging-cards/e-mobility-charging-sessions-overview/EMobilityChargingSessionsOverviewModal'
import EMobilityWallboxChargingSessionsOverview, {
  EMobilityWallboxChargingSessionsOverviewProps,
} from 'src/Libs/e-mobility/emobility-wallbox/e-mobility-wallbox-charging-sessions/EMobilityWallboxChargingSessionsOverview'
import EMobilityWallboxTariffsEditor, {
  EMobilityWallboxTariffsEditorProps,
} from 'src/Libs/e-mobility/emobility-wallbox/e-mobility-wallbox-tariffs-editor/EMobilityWallboxTariffsEditor'
import {
  ManageModeConfirmationDialog,
  ManageModeConfirmationDialogProps,
} from 'src/Libs/e-mobility/charging-cards/components/link-wallboxes/ManageModeConfirmationDialog'
import {
  AddDeviceDialogProps,
  AddDeviceDialog,
  ActivateModbusTcpServerDialog,
  ActivateModbusTcpServerDialogProps,
  EmcPairingDialog,
  EmcPairingDialogProps,
  InstallationPairingDialog,
  InstallationPairingDialogProps,
  SmartMeterGatewayPairingDialog,
  SmartMeterGatewayPairingDialogProps,
} from 'src/Libs/flow/advanced-settings/overview/components/Dialogs'
import {
  ModbusTcpPairingDialogProps,
  EebusPairingDialogProps,
  EnterOcppPasswordDialogProps,
  ModbusTcpPairingDialog,
  EebusPairingDialog,
  EnterOcppPasswordDialog,
} from 'src/Libs/flow/advanced-settings/charging-stations/components/Dialogs'
import { EditBadgeDialog } from 'src/Libs/flow/advanced-settings/components/Dialogs/components/EditBadgeDialog'
import { HeatpumpPairingDialog } from 'src/Libs/flow/advanced-settings/heatpump'
import { HeatpumpPairingDialogProps } from 'src/Libs/flow/advanced-settings/heatpump/components/Dialogs/HeatpumpPairingDialog'
import {
  Htc320hIoPairingDialogProps,
  MyPvPairingDialogProps,
  Htc320hIoPairingDialog,
  MyPvPairingDialog,
} from 'src/Libs/flow/advanced-settings/io/components/Dialogs'
import { StoragePairingDialogProps, StoragePairingDialog } from 'src/Libs/flow/advanced-settings/storage/components'
import { MeterPairingDialog, MeterPairingDialogProps } from 'src/Libs/flow/advanced-settings/powermeter/components/Dialog/MeterPairingDialog'
import ProtectedFileDialog from 'src/Libs/downloads/components/ProtectedFileDialog'
import {
  HoldingTimeEditorDialog,
  HoldingTimeEditorDialogProps,
  PhaseManagementEditorDialog,
  PhaseManagementEditorDialogProps,
} from 'src/Libs/flow/end-user-settings/wallbox/components/advancedEvseSettings'
import { ChargingScheduleEditorDialog, ChargingScheduleEditorDialogProps } from 'src/Libs/flow/end-user-settings/wallbox/components/chargingPriority'
import { BoilerScheduleEditorDialog, BoilerScheduleEditorDialogProps } from 'src/Libs/flow/end-user-settings/boiler/components'
/** Old E-Mobility END */
import { ChargingSessionDetailsDialogV1FlowProps, ChargingSessionDetailsV1FlowDialog } from 'src/Libs/flow/dialogs/ChargingSessionDetailsDialog'
import UpdateWarrantyModal, { UpdateWarrantyDialogProps } from 'src/Libs/installation-details/components/modals/UpdateWarrantyModal'
import ReasonDialog, { ReasonDialogProps } from 'src/Components/modals/ReasonDialog'
import { z } from 'zod'
import { ScanNetworkDialog, ScanNetworkDialogProps } from 'src/Libs/installations/components/new-installation/configuration'
import PowerMeterScanDialog, {
  PowerMeterScanDialogProps,
} from 'src/Libs/installations/components/new-installation/configuration/power-meters/PowerMeterScanDialog'

export type ModalType =
  | Modal<UserEditorProps, 'userEditor'>
  | Modal<ActuatorEditorProps, 'actuatorEditor'>
  | Modal<PasswordEditorProps, 'passwordEditor'>
  | Modal<PvModuleEditorProps, 'pvModuleEditor'>
  | Modal<BatteryExportModuleProps, 'batteryExportModuleEditor'>
  | Modal<ConfirmationModalProps, 'confirmationModal'>
  | Modal<InformationModalProps, 'informationModal'>
  | Modal<SystemChartEditorProps, 'systemChartEditor'>
  | Modal<InstallationAddressEditorProps, 'installationAddressEditor'>
  | Modal<IPinEditorProps, 'iPinEditor'>
  | Modal<ProjectNameEditorProps, 'projectNameEditor'>
  | Modal<UserEditorProps, 'companyEditor'>
  | Modal<ChartLayoutEditorProps, 'chartLayoutEditor'>
  | Modal<FarmParticipantSelectorProps, 'farmParticipantSelector'>
  | Modal<InviteEditorProps, 'companyInviteEditor'>
  | Modal<InstallationStatementDialogProps, 'installationStatementDialog'>
  | Modal<InstallationDocumentUpload, 'installationDocumentUpload'>
  | Modal<AddWallboxDialogProps, 'addWallboxDialog'>
  | Modal<LogoutModalProps, 'logoutModal'>
  | Modal<ExtensionDetailsProps, 'luoxDirectMarketingModal'>
  | Modal<ExtensionDetailsProps, 'luoxDynamicTariffModal'>
  | Modal<ExtensionDetailsProps, 'inexogyModal'>
  | Modal<ExtensionDetailsProps, 'eonModal'>
  | Modal<ExtensionDetailsProps, 'ai360PowerShareModal'>
  | Modal<ExtensionDetailsProps, 'ai360PowerFixModal'>
  | Modal<ExtensionDeleteConnectionModalProps, 'ai360PowerShareDeleteConnectionModal'>
  | Modal<ExtensionDeleteConnectionModalProps, 'ai360PowerFixDeleteConnectionModal'>
  | Modal<SmartMeterRecommendationModalProps, 'ai360SmartMeterRecommendationModal'>
  | Modal<ExtensionDetailsProps, 'oStromModal'>
  | Modal<ExtensionDeleteConnectionModalProps, 'luoxDynamicTariffDeleteConnectionModal'>
  | Modal<ExtensionDeleteConnectionModalProps, 'oStromDeleteConnectionModal'>
  | Modal<ExtensionDetailsProps, 'tibberModal'>
  | Modal<ExtensionDeleteConnectionModalProps, 'tibberDeleteConnectionModal'>
  | Modal<LanguageModalProps, 'languageModal'>
  | Modal<DeleteProfileProps, 'deleteProfileDialog'>
  | Modal<NotificationModalProps, 'notificationModal'>
  | Modal<ImagePreviewProps, 'imagePreviewEditor'>
  | Modal<EMobilityChargingSessionDetailModalProps, 'chargingSessionDetails'>
  | Modal<ToggleIdlePeriodDialogProps, 'smartChargeToggleIdlePeriodDialog'>
  | Modal<InstallationAccessInviteDialogProps, 'installationAccessInviteDialog'>
  | Modal<InstallationAccessSettingsDialogProps, 'installationAccessSettingsDialog'>
  | Modal<ShopMoreInfoModalProps, 'shopMoreInfo'>
  | Modal<ShopLeavingConfirmationModalProps, 'shopLeavingConfirmation'>
  | Modal<ShopCheckoutSideBarModalProps, 'openShopCheckoutSideBar'>
  | Modal<ShopPowerMeterModalProps, 'openShopPowerMeter'>
  | Modal<ShopTransformerModalProps, 'openShopTransformerModal'>
  | Modal<ShopAdditionalProductsModalProps, 'openShopAdditionalProductsModal'>
  | Modal<ShopRetrofitBatteryModalProps, 'openShopRetrofitBatteryModal'>
  | Modal<SimpleTextDialogProps, 'simpleTextDialog'>
  | Modal<HotWaterSupplyDialogProps, 'hotWaterSupplyDialog'>
  | Modal<ShopBillingAndShippingAddressModalProps, 'shopBillingAndShippingModal'>
  | Modal<ShopHintModalProps, 'shopHintModal'>
  | Modal<ShopNewShippingAddressModalProps, 'shopNewShippingAddressModal'>
  | Modal<ShopSaveSystemConfigurationModalProps, 'shopSaveSystemConfiguration'>
  | Modal<ShopUpdateSystemConfigurationModalProps, 'shopUpdateSystemConfiguration'>
  | Modal<ShopRetrofitBatterySingleProductModalProps, 'shopRetrofitBatterySingleProduct'>
  | Modal<ShopOrderHistoryDetailsModalProps, 'shopOrderHistoryDetails'>
  | Modal<ShopAdminModalProps, 'shopAdminModal'>
  | Modal<ShopProductImageModalProps, 'shopProductImageModal'>
  | Modal<CompanyShowroomProps, 'companyShowroomModal'>
  | Modal<RenameInstallationModalProps, 'renameInstallationModal'>
  | Modal<NotificationMessageModalProps, 'notificationMessageModal'>
  | Modal<PowerPriceChartModalProps, 'powerPriceChartModal'>
  | Modal<ManufacturerConnectionTermsProps, 'manufacturerConnectionTermsDialog'>
  | Modal<ChargeModalProps, 'chargeModal'>
  | Modal<AssignManagerDialogProps, 'assignManagerDialog'>
  | Modal<ShopPromotionCodeModalProps, 'shopPromotionCodeModal'>
  | Modal<ShopSmartMeterModalProps, 'shopSmartMeterModal'>
  | Modal<ShopSmartMeterDocumentUploadModalProps, 'shopSmartMeterDocumentUploadModal'>
  | Modal<InstallationAccessRequestDialogProps, 'installationAccessRequestDialog'>
  | Modal<OwnerAccessRequestDialogProps, 'ownerAccessRequestDialog'>
  | Modal<InstallationAccessRightDialogProps, 'installationAccessRightDialog'>
  | Modal<WallboxWeekDaysDialogProps, 'wallboxWeekDaysDialog'>
  | Modal<DashboardEditorProps, 'dashboardEditor'>
  | Modal<CookieModalProps, 'cookieModal'>
  | Modal<TestRunDetailsModalProps, 'testRunDetailsModal'>
  | Modal<ChangeInstallationOwnerModalProps, 'changeInstallationOwnerModal'>
  | Modal<EditAccessStartAtModalProps, 'editAccessStartAtModal'>
  | Modal<GrantCompanyAccessModalProps, 'grantCompanyAccessModal'>
  | Modal<GrantInstallerAccessModalProps, 'grantInstallerAccessModal'>
  | Modal<ChangeLocationDialogProps, 'changeInstallationLocationModal'>
  | Modal<DynamicTariffSettingsDateRangeModalProps, 'dynamicTariffSettingsDateRangeModal'>
  /** New E-Mobility START */
  | Modal<NoDateRangeSelectedExportSessionsDialogProps, 'noDateRangeSelectedExportSessions'>
  | Modal<InvalidSelectedDateRangeExportSessionDialogProps, 'invalidDateRangeSelectedExportSessions'>
  | Modal<ReimbursementExportSessionsDialogProps, 'reimbursementExportSessions'>
  | Modal<DeleteChargingCardDialogProps, 'deleteChargingCard'>
  | Modal<AddTariffDialogProps, 'addTariffDialog'>
  | Modal<DeleteTariffDialogProps, 'deleteTariffDialog'>
  | Modal<EditTariffDialogProps, 'editTariffDialog'>
  | Modal<TariffDetailsDialogProps, 'tariffDetailsDialog'>
  | Modal<ChargingCardDetailsModalProps, 'chargingCardDetailsDialog'>
  | Modal<LinkedWallboxesOverviewDialogProps, 'linkedWallboxesOverview'>
  | Modal<UnmanagedModeInfoDialogProps, 'unmanagedModeOverview'>
  | Modal<AssignTariffDialogProps, 'assignTariffDialog'>
  | Modal<EditChargingCardDialogProps, 'editChargingCardDialog'>
  | Modal<ChargingCardToWallboxLinkDialogProps, 'chargingCardToWallboxLinkModal'>
  | Modal<ManageModeConfirmationDialogProps, 'unlinkChargingCards'>
  /** New E-Mobility END */

  /** Old E-Mobility START */
  | Modal<EMobilityChargingCardEditorProps, 'emobilityChargingCardEditor'>
  | Modal<EMobilityChargingSessionDetailModalPropsV1, 'chargingSessionDetailsV1'>
  | Modal<ExportChargingCardEditorProps, 'emobilityExportChargingCardEditor'>
  | Modal<EMobilityChargingSessionsOverviewModalProps, 'chargingSessionsOverview'>
  | Modal<EMobilityWallboxChargingSessionsOverviewProps, 'wallboxChargingSessionsOverview'>
  | Modal<EMobilityWallboxTariffsEditorProps, 'wallboxTariffsEditor'>
  /** Old E-Mobility END */
  | Modal<AmazonCodeDialogProps, 'amazonCodeModal'>
  | Modal<DeleteProfileSurveyDialogProps, 'userDeletionSurvey'>
  | Modal<CategoryEditorProps, 'downloadCategoryEditor'>
  | Modal<DeleteCategoryProps, 'deleteCategoryDialog'>
  | Modal<MoveDownloadItemEditorProps, 'moveDownloadItemDialog'>
  | Modal<DownloadItemEditorProps, 'downloadItemEditor'>
  | Modal<UploadFileDialogProps, 'uploadFileDialog'>
  /** Flow start */
  | Modal<InstallationSaveDialogProps, 'openInstallationSaveDialog'>
  | Modal<InstallationDeleteDialogProps, 'openInstallationDeleteDialog'>
  | Modal<AddDeviceDialogProps, 'addDeviceDialog'>
  | Modal<EmcPairingDialogProps, 'emcPairingDialog'>
  | Modal<StoragePairingDialogProps, 'storagePairingDialog'>
  | Modal<ModbusTcpPairingDialogProps, 'modbusTcpPairingDialog'>
  | Modal<EebusPairingDialogProps, 'eebusPairingDialog'>
  | Modal<HeatpumpPairingDialogProps, 'heatpumpPairingDialog'>
  | Modal<MeterPairingDialogProps, 'meterPairingDialog'>
  | Modal<Htc320hIoPairingDialogProps, 'htc320hIoPairingDialog'>
  | Modal<MyPvPairingDialogProps, 'myPvPairingDialog'>
  | Modal<ActivateModbusTcpServerDialogProps, 'activateModbusTcpServerDialog'>
  | Modal<InstallationPairingDialogProps, 'installationPairingDialog'>
  | Modal<SmartMeterGatewayPairingDialogProps, 'smartMeterGatewayPairingDialog'>
  | Modal<EnterOcppPasswordDialogProps, 'enterOcppPasswordDialog'>
  | Modal<EditBadgeDialogProps, 'editBadgeDialog'>
  | Modal<HoldingTimeEditorDialogProps, 'holdingTimeEditorDialog'>
  | Modal<PhaseManagementEditorDialogProps, 'phaseManagementEditorDialog'>
  | Modal<ChargingScheduleEditorDialogProps, 'chargingScheduleEditorDialog'>
  | Modal<BoilerScheduleEditorDialogProps, 'boilerScheduleDialog'>
  | Modal<ChargingSessionDetailsDialogV1FlowProps, 'chargingSessionDetailsDialogV1Flow'>
  /** Flow ends */
  | Modal<ReplaceFileDialogProps, 'replaceFileDialog'>
  | Modal<ProtectedFileDialogProps, 'protectedFileDownloadDialog'>
  | Modal<UpdateWarrantyDialogProps, 'updateWarrantyDialog'>
  | Modal<ReasonDialogProps<z.Schema<unknown>, unknown>, 'reasonDialog'>
  | Modal<NewInstallationModalProps, 'newInstallationDialog'>
  | Modal<ScanNetworkDialogProps, 'scanNetworkForQntmsDialog'>
  | Modal<PowerMeterScanDialogProps, 'powerMeterScanDialog'>

export type ModalState = {
  readonly modals: ModalType[]
}

interface DialogProps {
  place: number
  modal: ModalType
}

const Dialog: React.FC<DialogProps> = ({ place, modal }) => {
  const dispatch = useDispatch()

  switch (modal.type) {
    case 'companyEditor':
      return <CompanyEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'userEditor':
      return <UserEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'iPinEditor':
      return <IPinEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'actuatorEditor':
      return <ActuatorEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'passwordEditor':
      return <PasswordEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'pvModuleEditor':
      return <PvModuleEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'batteryExportModuleEditor':
      return <BatterExportModuleEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'confirmationModal':
      return <ConfirmationDialog onClose={() => dispatch(removeModal())} {...modal} />
    case 'informationModal':
      return <InformationDialog onClose={() => dispatch(removeModal())} {...modal} />
    case 'systemChartEditor':
      return <SystemChartEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationAddressEditor':
      return <InstallationAddressEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chartLayoutEditor':
      return <ChartLayoutEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'farmParticipantSelector':
      return <FarmParticipantSelector {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'companyInviteEditor':
      return <InviteEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationStatementDialog':
      return <InstallationStatementDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'imagePreviewEditor':
      return <ImagePreviewModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationDocumentUpload':
      return <InstallationDocumentUploadModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'addWallboxDialog':
      return <AddWallboxDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'logoutModal':
      return <LogoutModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'luoxDirectMarketingModal':
      return <LuoxDirectMarketingDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'luoxDynamicTariffModal':
      return <LuoxDynamicTariffDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'luoxDynamicTariffDeleteConnectionModal':
      return <LuoxDynamicTariffDeleteConnectionModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'inexogyModal':
      return <InexogyDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'eonModal':
      return <EonDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ai360PowerShareModal':
      return <Ai360PowerShareDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ai360PowerFixModal':
      return <Ai360PowerFixDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ai360PowerShareDeleteConnectionModal':
      return <Ai360PowerShareDeleteConnectionModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ai360PowerFixDeleteConnectionModal':
      return <Ai360PowerFixDeleteConnectionModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ai360SmartMeterRecommendationModal':
      return <SmartMeterRecommendationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'oStromModal':
      return <OStromDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'oStromDeleteConnectionModal':
      return <OStromDeleteConnectionModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'tibberModal':
      return <TibberDetails {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'tibberDeleteConnectionModal':
      return <TibberDeleteConnectionModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'languageModal':
      return <LanguageModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'deleteProfileDialog':
      return <DeleteProfileDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'userDeletionSurvey':
      return <DeleteProfileSurveyDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'notificationModal':
      return <NotificationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargingSessionDetails':
      return <EMobilityChargingSessionDetailsModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'smartChargeToggleIdlePeriodDialog':
      return <ToggleIdlePeriodDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationAccessInviteDialog':
      return <InstallationAccessInviteDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'simpleTextDialog':
      return <SimpleTextDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationAccessSettingsDialog':
      return <InstallationAccessSettingsDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopMoreInfo':
      return <ShopMoreInfoModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopLeavingConfirmation':
      return <ShopLeavingConfirmationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'openShopCheckoutSideBar':
      return <ShopCheckoutSideBar {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'openShopPowerMeter':
      return <ShopPowerMeterModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'openShopTransformerModal':
      return <ShopTransformerModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'openShopAdditionalProductsModal':
      return <ShopAdditionalProductsModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'openShopRetrofitBatteryModal':
      return <ShopRetrofitBatteryModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'hotWaterSupplyDialog':
      return <HotWaterSupplyDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopBillingAndShippingModal':
      return <ShopBillingAndShippingAddressModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopHintModal':
      return <ShopHintModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopNewShippingAddressModal':
      return <ShopNewShippingAddressModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopSaveSystemConfiguration':
      return <ShopSaveSystemConfigurationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopUpdateSystemConfiguration':
      return <ShopUpdateSystemConfigurationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopRetrofitBatterySingleProduct':
      return <ShopRetrofitBatterySingleProductModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopOrderHistoryDetails':
      return <ShopOrderHistoryDetailsModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopAdminModal':
      return <ShopAdminModal onClose={() => dispatch(removeModal())} {...modal} place={place} />
    case 'shopProductImageModal':
      return <ShopProductImageModal onClose={() => dispatch(removeModal())} {...modal} place={place} />
    case 'companyShowroomModal':
      return <CompanyShowroomModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'renameInstallationModal':
      return <RenameInstallationModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'notificationMessageModal':
      return <NotificationMessageModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'powerPriceChartModal':
      return <PowerPriceChartModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'manufacturerConnectionTermsDialog':
      return <ManufacturerConnectionTermsDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargeModal':
      return <ChargeModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'assignManagerDialog':
      return <AssignManagerDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'shopPromotionCodeModal':
      return <ShopPromotionCodeModal onClose={() => dispatch(removeModal())} {...modal} place={place} />
    case 'shopSmartMeterModal':
      return <SmartMeterModal onClose={() => dispatch(removeModal())} {...modal} place={place} />
    case 'shopSmartMeterDocumentUploadModal':
      return <SmartMeterDocumentUploadModal onClose={() => dispatch(removeModal())} {...modal} place={place} />
    case 'installationAccessRequestDialog':
      return <InstallationAccessRequestDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'ownerAccessRequestDialog':
      return <OwnerAccessRequestDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'installationAccessRightDialog':
      return <InstallationAccessRightDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'wallboxWeekDaysDialog':
      return <WallboxWeekDaysDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'dashboardEditor':
      return <DashboardEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'cookieModal':
      return <CookieModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'testRunDetailsModal':
      return <TestRunDetailsModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'changeInstallationOwnerModal':
      return <ChangeInstallationOwnerModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'editAccessStartAtModal':
      return <EditAccessStartAtModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'grantCompanyAccessModal':
      return <GrantCompanyAccessModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'grantInstallerAccessModal':
      return <GrantInstallerAccessModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'changeInstallationLocationModal':
      return <ChangeLocationDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'dynamicTariffSettingsDateRangeModal':
      return <DynamicTariffSettingsDateRangeModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'amazonCodeModal':
      return <AmazonCodeDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'downloadCategoryEditor':
      return <CategoryEditor {...modal} onClose={() => dispatch(removeModal())} />
    case 'downloadItemEditor':
      return <DownloadItemEditor {...modal} onClose={() => dispatch(removeModal())} />
    case 'deleteCategoryDialog':
      return <DeleteCategoryDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'uploadFileDialog':
      return <UploadFileDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'moveDownloadItemDialog':
      return <MoveDownloadItemDialog {...modal} onClose={() => dispatch(removeModal())} />
    /** New E-Mobility START */
    case 'deleteChargingCard':
      return <DeleteChargingCardDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'noDateRangeSelectedExportSessions':
      return <NoDateRangeSelectedExportSessionsDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'reimbursementExportSessions':
      return <ReimbursementExportSessionsDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'invalidDateRangeSelectedExportSessions':
      return <InvalidSelectedDateRangeExportSessionDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'assignTariffDialog':
      return <AssignTariffDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'addTariffDialog':
      return <AddTariffDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'deleteTariffDialog':
      return <DeleteTariffDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'editTariffDialog':
      return <EditTariffDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'tariffDetailsDialog':
      return <TariffDetailsDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'editChargingCardDialog':
      return <EditChargingCardDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargingCardDetailsDialog':
      return <ChargingCardDetailsModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'linkedWallboxesOverview':
      return <LinkedWallboxesOverviewDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'unmanagedModeOverview':
      return <UnmanagedModeInfoDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'unlinkChargingCards':
      return <ManageModeConfirmationDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargingCardToWallboxLinkModal':
      return <ChargingCardToWallboxLinkDialog {...modal} onClose={() => dispatch(removeModal())} />
    /** New E-Mobility START */

    /** Old E-Mobility START */
    case 'wallboxChargingSessionsOverview':
      return <EMobilityWallboxChargingSessionsOverview {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'emobilityChargingCardEditor':
      return <EMobilityChargingCardEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargingSessionDetailsV1':
      return <EMobilityChargingSessionDetailsModalV1 {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'emobilityExportChargingCardEditor':
      return <ExportChargingCardEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'chargingSessionsOverview':
      return <EMobilityChargingSessionsOverviewModal {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'wallboxTariffsEditor':
      return <EMobilityWallboxTariffsEditor {...modal} onClose={() => dispatch(removeModal())} place={place} />
    /** Old E-Mobility END */

    /** Flow start */
    case 'openInstallationSaveDialog':
      return <InstallationSaveDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'openInstallationDeleteDialog':
      return <InstallationDeleteDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'addDeviceDialog':
      return <AddDeviceDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'emcPairingDialog':
      return <EmcPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'storagePairingDialog':
      return <StoragePairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'modbusTcpPairingDialog':
      return <ModbusTcpPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'eebusPairingDialog':
      return <EebusPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'heatpumpPairingDialog':
      return <HeatpumpPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'meterPairingDialog':
      return <MeterPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'htc320hIoPairingDialog':
      return <Htc320hIoPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'myPvPairingDialog':
      return <MyPvPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'activateModbusTcpServerDialog':
      return <ActivateModbusTcpServerDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'installationPairingDialog':
      return <InstallationPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'smartMeterGatewayPairingDialog':
      return <SmartMeterGatewayPairingDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'enterOcppPasswordDialog':
      return <EnterOcppPasswordDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'editBadgeDialog':
      return <EditBadgeDialog {...modal} onClose={() => dispatch(removeModal())} place={place} />
    case 'holdingTimeEditorDialog':
      return <HoldingTimeEditorDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'phaseManagementEditorDialog':
      return <PhaseManagementEditorDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'chargingScheduleEditorDialog':
      return <ChargingScheduleEditorDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'boilerScheduleDialog':
      return <BoilerScheduleEditorDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'chargingSessionDetailsDialogV1Flow':
      return <ChargingSessionDetailsV1FlowDialog {...modal} onClose={() => dispatch(removeModal())} />
    /** Flow ends */
    case 'replaceFileDialog':
      return <ReplaceFileDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'protectedFileDownloadDialog':
      return <ProtectedFileDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'updateWarrantyDialog':
      return <UpdateWarrantyModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'reasonDialog':
      return (
        <ReasonDialog
          {...modal}
          onClose={() => {
            dispatch(removeModal())
            modal.onClose?.()
          }}
        />
      )
    case 'newInstallationDialog':
      return <NewInstallationModal {...modal} onClose={() => dispatch(removeModal())} />
    case 'scanNetworkForQntmsDialog':
      return <ScanNetworkDialog {...modal} onClose={() => dispatch(removeModal())} />
    case 'powerMeterScanDialog':
      return <PowerMeterScanDialog {...modal} onClose={() => dispatch(removeModal())} />
    default:
      console.warn(`No modal found (modal.type=${modal.type})`)
      return <></>
  }
}

const ModalRoot = (): React.ReactElement => {
  const modals = useTypedSelector<ModalType[]>(state => state.modal.modals)

  return (
    <>
      {modals.map((modal, index) => (
        <Dialog key={index} place={index} modal={modal}></Dialog>
      ))}
    </>
  )
}

export default ModalRoot
